"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var core_1 = require("@angular/core");
var FormattingService = /** @class */ (function () {
    function FormattingService(localeService, currentLanguageProvider) {
        this.localeService = localeService;
        this.currentLanguageProvider = currentLanguageProvider;
    }
    FormattingService.prototype.formatDate = function (utcTime) {
        var _this = this;
        return this.getLocaleInfo().pipe(operators_1.mergeMap(function (localeInfo) {
            // dates (without time) in de, sets time equal 00:00 by utc
            // must be installed by localeInfo.timezoneOffset, for correct work
            return _this.localeService.formatDate(utcTime + localeInfo.timeZoneOffset * 1000, localeInfo.languageId);
        }));
    };
    FormattingService.prototype.formatTime = function (utcTime) {
        var _this = this;
        return this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.mergeMap(function (language) {
            return _this.localeService.formatTime(utcTime, language.getId());
        }));
    };
    FormattingService.prototype.formatDateTime = function (utcTime) {
        var _this = this;
        return this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.mergeMap(function (language) {
            return _this.localeService.formatDateTime(utcTime, language.getId());
        }));
    };
    FormattingService.prototype.formatNumber = function (number) {
        var _this = this;
        return this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.mergeMap(function (language) {
            return _this.localeService.formatNumber(number, language.getId());
        }));
    };
    FormattingService.prototype.getLocaleInfo = function () {
        var _this = this;
        return this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.mergeMap(function (language) {
            return _this.localeService.getLocaleInfo(language.getId());
        }), operators_1.map(function (value) {
            if (value['localeInfoDto']) {
                return value['localeInfoDto'];
            }
            return value;
        }));
    };
    FormattingService.prototype.parseNumber = function (num) {
        return this.getLocaleInfo().pipe(operators_1.map(function (localeInfo) {
            return parseFloat(num
                .split(localeInfo.numberFormat.groupSeparator)
                .join('') // replaceAll
                .replace(localeInfo.numberFormat.decimalSeparator, '.'));
        }));
    };
    FormattingService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_locale_service_client_js_1.LocaleService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], FormattingService);
    return FormattingService;
}());
exports.FormattingService = FormattingService;
//# sourceMappingURL=formatting.service.js.map